import * as React from "react"
import { Box } from "@mui/material"

import {DATE_PERIODS} from "@constants";
import {DateRangeBlock} from "@components";
import { evolutionStockCurrentPeriod } from "../../@signals"
import {rangeDatesPricingDiscountStockEvolution} from "./Ranges";


export default function PriceDiscountStockEvolutionChartToolbar({ dateRange, onChange }) {
    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>
        <DateRangeBlock
            currentPeriodLabel={evolutionStockCurrentPeriod.value}
            maxDays={365}
            value={dateRange}
            ranges={rangeDatesPricingDiscountStockEvolution}
            onChange={onChange}
            onOk = { () => evolutionStockCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />
    </Box>
}